/** Posts without artwork get a generated card; this tells the UI which images are generated. */
export const GENERATED_CARD_PREFIX = '/api/post-card/';

export const generatedCardPath = (slug: string) =>
  `${GENERATED_CARD_PREFIX}${slug}`;

export const isGeneratedImage = (src?: string) =>
  Boolean(src?.startsWith(GENERATED_CARD_PREFIX));
